import { useEffect, useRef, useState } from "react";
import { streamAgent } from "../api";
/**
 * Opens an SSE connection to /api/agent/stream/{sessionId} when sessionId changes.
 * Accumulates AgentStepEvent[] in state and closes the connection on cleanup or error.
 *
 * Requirements: 12.2
 */
export function useAgentStream(sessionId) {
    const [steps, setSteps] = useState([]);
    const [error, setError] = useState(null);
    const [connected, setConnected] = useState(false);
    const esRef = useRef(null);
    useEffect(() => {
        // Reset state when sessionId changes
        setSteps([]);
        setError(null);
        setConnected(false);
        if (!sessionId)
            return;
        const es = streamAgent(sessionId);
        esRef.current = es;
        es.onopen = () => {
            setConnected(true);
        };
        es.onmessage = (event) => {
            try {
                const step = JSON.parse(event.data);
                setSteps((prev) => [...prev, step]);
            }
            catch (_a) {
                // Ignore malformed events
            }
        };
        es.onerror = () => {
            setError("SSE connection error");
            setConnected(false);
            es.close();
        };
        return () => {
            es.close();
            esRef.current = null;
            setConnected(false);
        };
    }, [sessionId]);
    return { steps, error, connected };
}
